<template>
    <div>
        <div :class="layoutClasses" uk-grid uk-scrollspy="target: > div; cls: uk-animation-slide-bottom-small; delay: 30">
          <product-card
              v-for="product in products"
              :product="product"
              :key="product.id"
              :routes="routes"
              :translations="translations"
          >
          </product-card>
        </div>

        <product-overview-pagination
            v-if="pagination.lastPage > 1"
            :pagination="pagination"
            :translations="translations"
            :routes="routes"
        >
        </product-overview-pagination>
    </div>
</template>

<script>
    import { EventBus } from "../EventBus";
    import ProductOverviewPagination from "./ProductOverviewPagination";
    import * as functions from "../functions.js";

    export default {
        name: "ProductsOverview",
        components: {ProductOverviewPagination},
        mounted(){
          EventBus.$on('RELOAD_PRODUCTS', products => {
            this.products = Object.assign({}, products.products);
            this.pagination = {};
            this.pagination = products.pagination;
          });
        },
        data(){
            return {
              products: this.initProducts.products,
              pagination: this.initProducts.pagination
            }

        },
        methods: {

        },
        props: {
            initProducts: {
                type: Object|Array,
                required: true
            },
            routes: {
                type: Object|Array,
                required: true
            },
            translations: {
                type: Object|Array,
                required: true
            },
            layoutClasses: {
                type: String,
                required: true,
                default() { return "uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l uk-grid"; }
            }
        }
    }
</script>

<style scoped>
</style>